export default "/assets/images/app-screen1.8141c91463564c20.jpg";